import 'core-js';

// xdomain.min.js (loaded in index.html) patches XMLHttpRequest before this bundle runs.
// Zone.js 0.14 is incompatible with being applied on top of xhook's fake XHR — it causes
// "Error: undefined" failures in xdomain's onreadystatechange handler that silently swallow
// API responses, leaving lookup modals empty even when the network call succeeds.
//
// Fix: disable xhook so zone.js patches the *native* XHR, then re-enable so xhook wraps
// zone.js's patched XHR. The require() call (not a static import) is intentional — static
// imports are hoisted by TypeScript before any code in this file runs, which would put
// zone.js back before the disable() call and defeat the purpose.
(window as any).xhook?.disable();
// eslint-disable-next-line @typescript-eslint/no-require-imports
require('zone.js');
(window as any).xhook?.enable();

